export default __webpack_public_path__ + "static/onetag-b356018d233bce3648ce13954cdc17eb.svg";